export default __webpack_public_path__ + "static/media/D2B.a1e36402.png";